// extracted by mini-css-extract-plugin
export var authorsData = "styles-mod--authors-data--fb6be";
export var desktopView = "styles-mod--desktop-view--003a0";
export var mobileView = "styles-mod--mobile-view--ecf4d";
export var name = "styles-mod--name--06535";
export var position = "styles-mod--position--1c124";
export var recipesAuthors = "styles-mod--recipes-authors--66666";
export var singleAuthor = "styles-mod--single-author--18598";